import { render } from "./ProductConfirm.vue?vue&type=template&id=2bf0e212&scoped=true&ts=true"
import script from "./ProductConfirm.vue?vue&type=script&lang=ts"
export * from "./ProductConfirm.vue?vue&type=script&lang=ts"

import "./ProductConfirm.vue?vue&type=style&index=0&id=2bf0e212&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf0e212"]])

export default __exports__